var React = require('react');

function Chart (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M20.9533 12.7738H25.6667C25.1172 7.27059 20.7293 2.88275 15.2262 2.33325V7.04659C18.151 7.54008 20.4598 9.84892 20.9533 12.7738Z","key":0}),React.createElement("path",{"d":"M14.0595 20.9404C10.199 20.9404 7.0595 17.8009 7.0595 13.9404C7.0595 10.4789 9.58767 7.60309 12.8928 7.04659V2.33325C7.00584 2.92125 2.39284 7.90175 2.39284 13.9404C2.39284 20.3734 7.6265 25.6071 14.0595 25.6071C20.0982 25.6071 25.0787 20.9941 25.6667 15.1071H20.9533C20.3957 18.4123 17.521 20.9404 14.0595 20.9404Z","key":1})]);
}

Chart.defaultProps = {"width":"28","height":"28","viewBox":"0 0 28 28","fill":"none"};

module.exports = Chart;

Chart.default = Chart;
